module.exports = __webpack_public_path__ + "static/media/Bottom-grey.5ba1ed57.svg";